import { useCallback, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { MenuList } from "../MenuList";
import { MenuFooter } from "../MenuFooter";
import { ScrollbarWrapper } from "../../../../components/ScrollbarWrapper";

import logoSmall from "../../../../assets/images/logo-small.svg";
import logoLarge from "../../../../assets/images/logo-large.svg";
import { notificationsManagement } from "../../../../hooks/api/NotificationsManagement/NotificationsManagement";
import { useUserToken } from "../../../../hooks/core/UserToken";
import { useDispatch, useSelector } from "react-redux";
import { setUser } from "../../../../slices/User";
import { roles } from "../../../../services/utils/Roles"

const SideMenu = ({ isCollapsed, toggleSideMenu }) => {
    const { t } = useTranslation("common");
    const [isHovered, setIsHovered] = useState(false);
    const [activeTab, setActiveTab] = useState("dashboard");

    const {useTotalUnreadMutation} = notificationsManagement;
    const [totalUnreadList] = useTotalUnreadMutation();
    const userInfo = useSelector(state=>state.user.user);
    const [{ getDecoded }] = useUserToken();
    const decodedToken = getDecoded();

    const location = useLocation();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const getMenuListTop = () => {
        switch (true) {
            case decodedToken?.roles.includes(roles.SUPER_ADMIN) || decodedToken?.roles.includes(roles.DIRECTOR) || decodedToken?.roles.includes(roles.DIRECTOR_OF_STUDIES):
                return [
                    { label: t("Dashboard"), href: "/dashboard", icon: "ri-dashboard-horizontal-line", className: "side-menu__item " },
                    { label: t("calendar.title"), href: "/calendar-featured/day-view", icon: "fa-light fa-calendar-lines", className: "side-menu__item " },
                    { label: t("groups.title"), href: "/groups", icon: "fa-light fa-users", className: "side-menu__item " },
                    { label: t("students.title"), href: "/students", icon: "fa-light fa-user-graduate", className: "side-menu__item " },
                    { label: t("guardians.title"), href: "/guardians", icon: "ri-parent-line", className: "side-menu__item " },
                    { label: t("employees.title"), href: "/employees", icon: "fa-light fa-user-tie", className: "side-menu__item " },
                    // { label: t("students.tests"), href: "/tests", icon: "fa-light fa-file-lines", className: "side-menu__item " },
                    // { label: t("report.title"), href: "/reports", icon: "fa-light fa-clipboard", className: "side-menu__item " },
                    { label: t("calls.title"), href: "/calls", icon: "fa-light fa-phone", className: "side-menu__item " },
                ];
            case decodedToken?.roles.includes(roles.SECRETARY):
                return [
                    { label: t("Dashboard"), href: "/dashboard", icon: "ri-dashboard-horizontal-line", className: "side-menu__item " },
                    { label: t("calendar.title"), href: "/calendar-featured/day-view", icon: "fa-light fa-calendar-lines", className: "side-menu__item " },
                    { label: t("groups.title"), href: "/groups", icon: "fa-light fa-users", className: "side-menu__item " },
                    { label: t("students.title"), href: "/students", icon: "fa-light fa-user-graduate", className: "side-menu__item " },
                    { label: t("guardians.title"), href: "/guardians", icon: "ri-parent-line", className: "side-menu__item " },
                    // { label: t("students.tests"), href: "/tests", icon: "fa-light fa-file-lines", className: "side-menu__item " },
                    // { label: t("report.title"), href: "/reports", icon: "fa-light fa-clipboard", className: "side-menu__item " },
                    { label: t("calls.title"), href: "/calls", icon: "fa-light fa-phone", className: "side-menu__item " },
                ];
            case decodedToken?.roles.includes(roles.PROFESSOR) || decodedToken?.roles.includes(roles.PROFESSOR_COORDINATOR):
                return [
                    { label: t("calendar.title"), href: "/calendar-featured/day-view", icon: "fa-light fa-calendar-lines", className: "side-menu__item " },
                    { label: t("groups.title"), href: "/groups", icon: "fa-light fa-users", className: "side-menu__item " },
                    // { label: t("students.tests"), href: "/tests", icon: "fa-light fa-file-lines", className: "side-menu__item " },
                    // { label: t("report.title"), href: "/reports", icon: "fa-light fa-clipboard", className: "side-menu__item " },
                ];
            case decodedToken?.roles.includes(roles.MARKETING_MANAGER):
                return [
                    { label: t("calendar.title"), href: "/calendar-featured/day-view", icon: "fa-light fa-calendar-lines", className: "side-menu__item " },
                    { label: t("calls.title"), href: "/calls", icon: "fa-light fa-phone", className: "side-menu__item " },
                ];  
            case decodedToken?.roles.includes(roles.STUDENT):
                return [
                    { label: t("calendar.title"), href: "/calendar-featured/day-view", icon: "fa-light fa-calendar-lines", className: "side-menu__item " },
                    { label: t("documents"), href: "/documents", icon: "fa-light fa-file", className: "side-menu__item " },
                ];  
            // case decodedToken?.roles.includes(roles.GUARDIAN):
            //     return [
            //         { label: t("Dashboard"), href: "/a", icon: "ri-dashboard-horizontal-line", className: "side-menu__item " },
            //         { label: t("calendar.title"), href: "/b", icon: "fa-light fa-calendar-lines", className: "side-menu__item " },
            //         { label: t("documents"), href: "/c", icon: "fa-light fa-file", className: "side-menu__item " },
            //     ]; 
            default:
                return [
                    { label: t("calendar.title"), href: "/calendar-featured/day-view", icon: "fa-light fa-calendar-lines", className: "side-menu__item " },
                ]; 
        }
    };

    const getMenuListBottom = () => {
        switch (true) {
            case decodedToken?.roles.includes(roles.SUPER_ADMIN) || decodedToken?.roles.includes(roles.DIRECTOR) || decodedToken?.roles.includes(roles.DIRECTOR_OF_STUDIES):
                return [
                    { label: t("notifications.title"), href: "/notifications", icon: "fa-light fa-bell", className: "side-menu__item ", badge: userInfo.totalUnread},
                    { label: t("support.title"), href: "/support", icon: "fa-light fa-circle-question", className: "side-menu__item " },
                    { label: t("settings.title"), href: "/settings", icon: "fa-light fa-gear", className: "side-menu__item "},
                ];
            case decodedToken?.roles.includes(roles.SECRETARY) :
                return [
                    { label: t("notifications.title"), href: "/notifications", icon: "fa-light fa-bell", className: "side-menu__item ", badge: userInfo.totalUnread},
                    { label: t("support.title"), href: "/support", icon: "fa-light fa-circle-question", className: "side-menu__item " },
                ];
            case decodedToken?.roles.includes(roles.PROFESSOR_COORDINATOR):
                return [
                    { label: t("notifications.title"), href: "/notifications", icon: "fa-light fa-bell", className: "side-menu__item ", badge: userInfo.totalUnread},
                    { label: t("settings.title"), href: "/settings", icon: "fa-light fa-gear", className: "side-menu__item "},
                ];
            case decodedToken?.roles.includes(roles.PROFESSOR) || decodedToken?.roles.includes(roles.STUDENT) || decodedToken?.roles.includes(roles.MARKETING_MANAGER) || decodedToken?.roles.includes(roles.DESIGNER):
                return [
                    { label: t("notifications.title"), href: "/notifications", icon: "fa-light fa-bell", className: "side-menu__item ", badge: userInfo.totalUnread},
                ];
            default:
                return [
                    { label: t("notifications.title"), href: "/notifications", icon: "fa-light fa-bell", className: "side-menu__item ", badge: userInfo.totalUnread},
                ];
        }
    };

    const menuListTop = getMenuListTop();
    const menuListBottom = getMenuListBottom();

    const totalUnreads = () =>{
        totalUnreadList(decodedToken?.id).then((result) => {
            const totalUnread = result?.data?.totalRecords;
            dispatch(setUser({totalUnread}));
        });
    };

    const handleActiveTab = (tab = "", dropdown) => {
        if (dropdown) {
            const updatedActiveTab = activeTab === tab ? "" : tab;
            setActiveTab(updatedActiveTab);
        } else {
            setActiveTab(tab);
        }
    };

    const handleHover = useCallback(
        (isHovered) => {
            if (isCollapsed) {
                setIsHovered(isHovered);
            }
        },
        [isCollapsed],
    );

    useEffect(() => {
        if (location.pathname) {
            const allMenuItems = [...menuListTop, ...menuListBottom];
            const baseTab = allMenuItems.find((item) => location.pathname.startsWith(item.href));

            if (baseTab && baseTab.href) {
                if (location.pathname.startsWith(baseTab.href)) {
                    setActiveTab(baseTab.href);
                }
            } else {
                console.log("No active route");
            }
        }
        totalUnreads();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.pathname, t]);

    return (
        <aside id="sideMenu" className={`side-menu ${isCollapsed ? "side-menu--colapsed" : ""} ${isHovered ? "side-menu--hover" : ""}`}>
            <button id="btnMenu" className={`btn-menu ${isCollapsed ? "active" : ""}`} onClick={toggleSideMenu}>
                <div>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
            </button>
            <div className="side-menu__wrap" onMouseOver={() => handleHover(true)} onMouseOut={() => handleHover(false)}>
                <div className="side-menu__header">
                    <div className="side-menu__logo" onClick={() => navigate("/calendar-featured/day-view")} style={{ cursor: "pointer" }}>
                        <img className="side-menu__logo-small" src={logoSmall} alt="" />
                        <img className="side-menu__logo-full" src={logoLarge} alt="" />
                    </div>
                </div>
                <ScrollbarWrapper
                    className="side-menu__body"
                    id="sideMenuScrollbar"
                    options={{
                        removeXTrack: true,
                        observeResize: ".side-menu__items-bottom",
                    }}
                >
                    <MenuList className="side-menu__items-top" list={menuListTop} activeTab={activeTab} onMenuItemClick={handleActiveTab} />
                    <MenuList className="side-menu__items-bottom" list={menuListBottom} activeTab={activeTab} onMenuItemClick={handleActiveTab} />
                </ScrollbarWrapper>
                <MenuFooter onMenuItemClick={handleActiveTab} />
            </div>
        </aside>
    );
};

export default SideMenu;
